import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { useRoutesStore } from '@/store/modules/routes';
import { translate } from '@/i18n';
import { isExternal } from '@/utils/validate';
import { openFirstMenu } from '@/config';

import { useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import { nextTick } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    layout: {
      type: String,
      default: ''
    }
  },
  setup(__props, {
    expose: __expose
  }) {
    __expose();
    const router = useRouter();
    const routesStore = useRoutesStore();
    const {
      getTab: tab,
      getTabMenu: tabMenu,
      getRoutes: routes
    } = storeToRefs(routesStore);
    const handleTabClick = () => {
      nextTick(() => {
        if (isExternal(tabMenu.value.path)) {
          window.open(tabMenu.value.path);
          setTimeout(() => {
            router.push('/');
          }, 1000);
        } else if (openFirstMenu) router.push(tabMenu.value.redirect || tabMenu.value);
      });
    };
    const __returned__ = {
      router,
      routesStore,
      tab,
      tabMenu,
      routes,
      handleTabClick,
      get translate() {
        return translate;
      }
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
});